import { AnimationSource } from '@euler/assets';
import AnimatedLottieView from 'lottie-react-native';
import { memo } from 'react';
import { useWindowDimensions, View } from 'react-native';

export const DefaultTVLoader = memo(() => {
  const { width, height } = useWindowDimensions();
  return (
    <View
      css={`
        flex: 1;
        align-items: center;
        justify-content: center;
      `}
    >
      <AnimatedLottieView
        source={AnimationSource.loadingCircles}
        autoPlay
        loop={true}
        css={`
          width: ${width * 0.5}px;
          height: ${height * 0.5}px;
        `}
      />
    </View>
  );
});
